import React, { useState } from "react";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormHelperText,
    FormLabel,
    Input,
    Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useMediaQuery } from "react-responsive";
import loginBackground from "../../images/loginBackground.jpg";
import createPotentialClient from "./services/index.service";

export default function CreateClientFeature() {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        clientName: "",
        agreeToTerms: false,
    });
    const isPhone = useMediaQuery({ query: '(max-width: 768px)' });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);

    const validate = () => {
        const tempErrors = {};
        if (!formData.fullName) tempErrors.fullName = "Full Name is required";
        if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
            tempErrors.email = "Invalid email format";
        if (!formData.phone.match(/^\d{10}$/))
            tempErrors.phone = "Phone number must be 10 digits";
        if (!formData.clientName) tempErrors.clientName = "Client Name is required";
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        setSuccess(null);
        try {
            await createPotentialClient({
                full_name: formData.fullName, 
                email: formData.email,
                phone_number: formData.phone,
                client_name: formData.clientName,
            })
            setSuccess("Client Created Successfully");
            setFormData({ fullName: "", email: "", phone: "", clientName: "", agreeToTerms: false });
        } catch (error) {
            setSuccess("Error: Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    
    if(isPhone){
        return (
            <Box minHeight="100vh" p={4} boxShadow={3} bgcolor="white">
                <Typography variant="h5" align="center" gutterBottom>
                    Create Client Account
                </Typography>

                {success && <Alert severity={success.includes("Error") ? "error" : "success"}>{success}</Alert>}

                <form onSubmit={handleSubmit}>
                    <FormControl fullWidth margin="normal" error={!!errors.fullName}>
                        <FormLabel>Full Name</FormLabel>
                        <Input name="fullName" value={formData.fullName} onChange={handleChange} />
                        <FormHelperText>{errors.fullName}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.email}>
                        <FormLabel>Email</FormLabel>
                        <Input name="email" type="email" value={formData.email} onChange={handleChange} />
                        <FormHelperText>{errors.email}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.phone}>
                        <FormLabel>Phone Number</FormLabel>
                        <Input name="phone" type="tel" value={formData.phone} onChange={handleChange} />
                        <FormHelperText>{errors.phone}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.clientName}>
                        <FormLabel>Client Name</FormLabel>
                        <Input name="clientName" value={formData.clientName} onChange={handleChange} />
                        <FormHelperText>{errors.clientName}</FormHelperText>
                    </FormControl>

                    <FormControl margin="normal" error={!!errors.agreeToTerms} display="flex">
                        <Box display="flex" alignItems="flex-start" >
                            <Checkbox
                                name="agreeToTerms"
                                checked={formData.agreeToTerms}
                                onChange={handleChange}
                                color="primary"
                                display="flex"
                            />
                            <Typography variant="body2" component="span">
                                By supplying and entering your mobile number you agree to receive text messages from Hennessey Digital regarding your account. For more information, view our <a href="https://hennessey.com/terms-of-use/">Terms of Use</a> and <a href="https://hennessey.com/privacy-policy/">Privacy Policy</a> Message and data rates may apply. (Text HELP for help. Text STOP to cancel.)
                            </Typography>
                        </Box>
                        <FormHelperText>{errors.agreeToTerms}</FormHelperText>
                    </FormControl>

                    <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
                        {loading ? "Submitting..." : "Create Account"}
                    </Button>
                </form>
            </Box>
        );
    }

    return (
        <Box
            minHeight="100vh"
            width="100%"
            display="flex"
            alignItems="flex-start"
            justifyContent="center"
            flexDirection="column"
            style={{
                backgroundImage: `url(${loginBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <Box maxWidth="600px" ml={20}>
                <Box p={4} boxShadow={3} borderRadius={8} bgcolor="white">
                    <Typography variant="h5" align="center" gutterBottom>
                        Create Client Account
                    </Typography>

                    {success && <Alert severity={success.includes("Error") ? "error" : "success"}>{success}</Alert>}

                    <form onSubmit={handleSubmit}>
                        <FormControl fullWidth margin="normal" error={!!errors.fullName}>
                            <FormLabel>Full Name</FormLabel>
                            <Input name="fullName" value={formData.fullName} onChange={handleChange} />
                            <FormHelperText>{errors.fullName}</FormHelperText>
                        </FormControl>

                        <FormControl fullWidth margin="normal" error={!!errors.email}>
                            <FormLabel>Email</FormLabel>
                            <Input name="email" type="email" value={formData.email} onChange={handleChange} />
                            <FormHelperText>{errors.email}</FormHelperText>
                        </FormControl>

                        <FormControl fullWidth margin="normal" error={!!errors.phone}>
                            <FormLabel>Phone Number</FormLabel>
                            <Input name="phone" type="tel" value={formData.phone} onChange={handleChange} />
                            <FormHelperText>{errors.phone}</FormHelperText>
                        </FormControl>

                        <FormControl fullWidth margin="normal" error={!!errors.clientName}>
                            <FormLabel>Client Name</FormLabel>
                            <Input name="clientName" value={formData.clientName} onChange={handleChange} />
                            <FormHelperText>{errors.clientName}</FormHelperText>
                        </FormControl>

                        <FormControl margin="normal" error={!!errors.agreeToTerms} display="flex">
                            <Box display="flex" alignItems="flex-start" >
                                <Checkbox
                                    name="agreeToTerms"
                                    checked={formData.agreeToTerms}
                                    onChange={handleChange}
                                    color="primary"
                                    display="flex"
                                />
                                <Typography variant="body2" component="span">
                                    By supplying and entering your mobile number you agree to receive text messages from Hennessey Digital regarding your account. For more information, view our <a href="https://hennessey.com/terms-of-use/">Terms of Use</a> and <a href="https://hennessey.com/privacy-policy/">Privacy Policy</a> Message and data rates may apply. (Text HELP for help. Text STOP to cancel.)
                                </Typography>
                            </Box>
                            <FormHelperText>{errors.agreeToTerms}</FormHelperText>
                        </FormControl>

                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
                            {loading ? "Submitting..." : "Create Account"}
                        </Button>
                    </form>
                </Box>
            </Box>
        </Box>
    );
}